module.exports = __webpack_public_path__ + "img/legend-card1.62140d5a.png";